import React from 'react';

import { TASKS_STATUS_OPTIONS } from '@vlabs/api-bindings/src/constants';
import {
  CheckCircleIcon,
  CrossCircleIcon,
  LoaderIcon,
  StopCircleIcon,
  PauseCircleIcon,
} from '@vlabs/icons';

import './LPTasksProgressCell.sass';

export const LPTasksProgressCell = (status) => {
  const iconsMap = {
    0: <PauseCircleIcon className="ProgressCell" />,
    1: <LoaderIcon className="ProgressCell" />,
    2: <StopCircleIcon className="ProgressCell" />,
    3: <CrossCircleIcon className="ProgressCell_canceled" />,
    4: <LoaderIcon className="ProgressCell" />,
    5: <CheckCircleIcon className="ProgressCell_finished" />,
  };

  return (
    <div className="ProgressCell">
      <div title={TASKS_STATUS_OPTIONS[status].label}>
        {iconsMap[status]}
      </div>
    </div>
  );
};
